

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import UserApi from "../../../../services/UserApi.jsx";
import { separatorNumber, useGlobalFunc } from "../../../../global/constants.js";
import { Pagination } from "@mui/material";
import { useSelector } from "react-redux";


import moment from 'moment'



const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);
    const userInfo = useSelector(state => state.userInfo);

    const { setLoading, successToast, errorToast } = useGlobalFunc()

    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    const [data, setData] = useState(null)

    async function getData() {
        if (!(startDate && endDate)) {
            errorToast('請選擇時間間隔')
            return
        }

        const firstDate = new Date(startDate)

        const [year, month] = endDate.split('-');
        const nextMonth = new Date(year, month, 1);
        const lastDay = new Date(nextMonth - 1);

        const time1 = firstDate.getTime();
        const time2 = lastDay.getTime();

        // 检查哪个日期早于另一个日期
        if (time1 > time2) {
            errorToast('結束日期不能小於開始日期')
            return
        }




        console.log(lastDay)
        setLoading(true)
        try {
            let res = await UserApi.performanceGet({
                startDate:   moment(time1).format("YYYY-MM-DD"),
                endDate:  moment(time2).format("YYYY-MM-DD")
            })
            console.log(res.data.data)
            setData(res.data.data)

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)

    }

    useEffect(() => {
        // getData(1)
    }, []);

    return <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
        <div className="text-lg font-bold mb-4">{t('memberCenterType.usercollar')}</div>

        {
            userInfo &&
            <div className="mb-10">
                <div className="mb-6">
                    <div className="flex items-center mb-4">
                        <p className="flex-none w-32 text-sm font-bold">會員編號</p>
                        <p className="grow font-bold text-main4">{userInfo.systemId}</p>
                    </div>
                    <div className="w-full h-px bg-black06 "></div>
                </div>
                <div className="mb-6">
                    <div className="flex items-center mb-4">
                        <p className="flex-none w-32 text-sm font-bold">會員截止日</p>
                        <p className="grow font-bold text-main4">{userInfo.identityExpirationDate}</p>
                    </div>
                    <div className="w-full h-px bg-black06 "></div>
                </div>
                <div className="mb-6 hidden">
                    <div className="flex items-center mb-4">
                        <p className="flex-none w-32 text-sm font-bold">推薦人</p>
                        <p className="grow font-bold text-main4">{userInfo?.referralUser?.name}</p>
                    </div>
                    <div className="w-full h-px bg-black06 "></div>
                </div>
                <div className="mb-6">
                    <div className="flex items-center mb-4">
                        <p className="flex-none w-32 text-sm font-bold">當期累積總金額</p>
                        <p className="grow font-bold text-main4">${separatorNumber(userInfo.accumulatedSpentAmount)}</p>
                    </div>
                    <div className="w-full h-px bg-black06 "></div>
                </div>

            </div>
        }


        <div className="flex gap-4 items-center mb-4 flex-wrap">
            <div className="text-lg font-bold flex-none ">搜尋績效</div>
            <input value={startDate} onChange={(e) => setStartDate(e.target.value)} className="input w-full sm:w-1/3" type="month" />
            <input value={endDate} onChange={(e) => setEndDate(e.target.value)} className="input w-full sm:w-1/3" type="month" />
            <button onClick={() => getData()} className="btn1">送出</button>
        </div>
        {data &&
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-7">
                <div>
                    <p className="text-sm font-bold mb-2">總獎金</p>
                    <div className="input w-full" >
                        {data.orderReward.totalBonus}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">引薦獎金</p>
                    <div className="input w-full" >
                        {data.orderReward.refferralBonus}
                    </div>
                </div>


                <div >
                    <p className="text-sm font-bold mb-2">協談獎金</p>
                    <div className="input w-full" >
                        {data.orderReward.negotiationBonus}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">講師獎金</p>
                    <div className="input w-full" >
                        {data.orderReward.lecturerBonus}
                    </div>
                </div>

                <div>
                    <p className="text-sm font-bold mb-2">輔導獎金</p>
                    <div className="input w-full" >
                        {data.orderReward.coachingBonus}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">差額獎金</p>
                    <div className="input w-full" >
                        {data.orderReward.cashbackBonus}
                    </div>
                </div>
                <div className="">
                    <p className="text-sm font-bold mb-2">團隊月績效獎金</p>
                    <div className="input w-full" >
                        {data.orderPerformance.monthly}
                    </div>
                </div>

                <div>
                    <p className="text-sm font-bold mb-2">團隊季績效獎金（3/6/9/12）</p>
                    <div className="input w-full" >
                        {data.orderPerformance.quarterly}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">團隊年績效獎金（12）</p>
                    <div className="input w-full" >
                        {data.orderPerformance.annual}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">全球分紅</p>
                    <div className="input w-full" >
                    0
                    </div>
                </div>

            </div>
        }
    </div>

}

export default Home